import React, { Component } from 'react';
import { connect } from 'react-redux'

import axios from 'axios'

import { Button, Icon } from 'semantic-ui-react'

class DocumentManager extends Component {
	
	constructor(props) {
		super(props)
		this.state = { loading: false }
	}
	
	b64toBlob = (base64, type = 'image/pdf') => fetch(`data:${type};base64,${base64}`).then(res => res.blob())
	
	manageDocument = (e) => {
		
		this.setState({ loading: true });
		
		let type = this.props.type;
		
		switch (type) {
			case 'download':
				this.downloadDocument(e);
			break;
			case 'print':
				this.printDocument(e);
			break;
			default:
				// do nothing
			break;
		}
	}
	downloadDocument = async (e) => {
		
		if (window.cordova) {
			
			e.preventDefault();
			e.stopPropagation();
			
			try {
				
				let name = this.props.name,
					url = this.props.config.configRoot + '/config.php',
					values = { 'request': 'document', 'name': name }
				;
				
				const 	r = await axios.post(url, values, {headers: {'content-type': 'application/json'}}),
						response = r.data
				;
				
				if (response.success === false && response.msg.length > 0) {
					throw response.msg;
				}
				
				let blobbed = await this.b64toBlob(response.base64, 'image/' + response.type),
					dirName = window.cordova.file.externalDataDirectory
				;
				
				if (window.cordova.platformId === 'ios') {
					dirName = window.cordova.file.documentsDirectory;
				}
				
				window.resolveLocalFileSystemURL(dirName, function (dirEntry) {
					dirEntry.getFile(name, { create: true, exclusive: false }, function (fileEntry) {
						fileEntry.createWriter(function (fileWriter) {
							
							fileWriter.onwriteend = function() {
								
								let filePath = dirName + name;
								
								window.cordova.plugins.fileOpener2.open(
									filePath,
									'application/pdf',
									{
										error : function(e) {
											//alert('Error status: ' + e.status + ' - Error message: ' + e.message);
											console.log(e);
										},
										success : function () {
											console.log('file opened successfully');
										}
									}
								);
								
							};
							fileWriter.onerror = function (e) {
								alert('Failed file write: ' + e.toString());
							};
							
							fileWriter.write(blobbed);
							
						}, function (writerError) {
							//alert('Failed Writer Error: ' + writerError.code.toString());
							console.log(writerError);
						});
					}, function (fileError) {
						//alert('Failed File Error: ' + fileError.code.toString());
						console.log(fileError);
					});
				}, function (dirError) {
					//alert('Failed Directory Error: ' + dirError.code.toString());
					console.log(dirError);
				});
				
				this.setState({ loading: false });
				
			} catch (error) {
				console.log(error);
				this.setState({ loading: false });
			}
			
		} else {
			this.setState({ loading: false });
		}
	}
	printDocument = async (e) => {
		
		e.preventDefault();
		e.stopPropagation();
		
		if (window.cordova) {
			
			try {
				
				let url = this.props.config.configRoot + '/config.php',
					values = { 'request': 'document', 'name': this.props.name }
				;
				
				const 	r = await axios.post(url, values, {headers: {'content-type': 'application/json'}}),
						response = r.data
				;
				
				if (response.success === false && response.msg.length > 0) {
					throw response.msg;
				}
				
				let encodedString = response.base64;
				
				window.plugins.PrintPDF.print({
					data: encodedString,
					type: 'Data',
					title: 'Print Document',
					success: function() {
						this.setState({ loading: false });
					},
					error: function(data) {
						data = JSON.parse(data);
						this.setState({ loading: false });
						throw data.error;
					}
				});
				
				this.setState({ loading: false });
				
			} catch (error) {
				console.log(error);
				this.setState({ loading: false });
			}
			
		} else {
			
			let url = e.currentTarget.href,
				iframe = document.createElement('iframe')
			;
			
			iframe.id = 'pdfIframe';
			document.body.appendChild(iframe);
			iframe.style.display = 'none';
			
			iframe.onload = function () {
				setTimeout(function () {
					
					iframe.focus();
					iframe.contentWindow.print();
					URL.revokeObjectURL(url)
					
					this.setState({ loading: false });
					
				}, 1);
			};
			iframe.src = url;
			
			return true;
		}
	}
	
	render() {
		
		const { loading } = this.state;
		
		return (
			<Button
				as="a"
				icon
				download
				color={this.props.color}
				href={ '../config/downloads/' + this.props.name }
				target="_blank"
				onClick={this.manageDocument}
				loading={loading}
				disabled={loading}
			>
				<Icon name={this.props.type} />
			</Button>
		);
	}
}

const mapStateToProps = state => ({
	config: state.config.config
})

export default connect(
	mapStateToProps,
	null
)(DocumentManager)